import { SEND_EMAIL_INVOICE_ERROR, SEND_EMAIL_INVOICE_SUCCESS, SEND_EMAIL_INVOICE_REQUEST } from "./types";
import { BASEURL } from "../../constant/config.js";
const axios = require("axios");

export const sendEmailInvoice = (token, data) => dispatch => {
    dispatch({ type: SEND_EMAIL_INVOICE_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}communication/InvoiceEmail`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " +  token,
        },
        data
    })
        .then(response => {
            return dispatch({
                type: SEND_EMAIL_INVOICE_SUCCESS,
                payload: response.data,
            });
        })
        .catch(error => {
            return dispatch({ type: SEND_EMAIL_INVOICE_ERROR, payload: error.response });
        });
};

